import { loc } from '../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js';
import '../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js';
import IonResponseHelper from './IonResponseHelper.js';

/*!
 * Copyright (c) 2026, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Build a normalized error object from various error shapes
 * (IDX response, API error, network error, etc.).
 *
 * @param {object} error - the raw error (or rawIdxState if already unwrapped)
 * @param {function} [onUnsupportedError] - optional callback invoked when error is unrecognized
 * @returns {object} errorObj with responseJSON
 */
const buildErrorObject = (error, onUnsupportedError) => {
  if (IonResponseHelper.isIonErrorResponse(error)) {
    return IonResponseHelper.convertFormErrors(error);
  } else if (error.errorSummary) {
    return {
      responseJSON: error
    };
  } else {
    if (typeof onUnsupportedError === 'function') {
      onUnsupportedError(error);
    }
    return {
      responseJSON: {
        errorSummary: loc('error.unsupported.response', 'login')
      }
    };
  }
};

/**
 * Check if error is a rate limit error (429).
 * Handles both IDX API errors (tooManyRequests key) and standard API errors (E0000047 errorCode).
 */
const isRateLimitError = error => {
  var _error$responseJSON, _error$responseJSON$e, _error$responseJSON2, _error$responseJSON3;
  return !!((_error$responseJSON = error.responseJSON) !== null && _error$responseJSON !== void 0 && (_error$responseJSON$e = _error$responseJSON.errorSummaryKeys) !== null && _error$responseJSON$e !== void 0 && _error$responseJSON$e.includes('tooManyRequests') || ((_error$responseJSON2 = error.responseJSON) === null || _error$responseJSON2 === void 0 ? void 0 : _error$responseJSON2.errorCode) === 'E0000047' && !((_error$responseJSON3 = error.responseJSON) !== null && _error$responseJSON3 !== void 0 && _error$responseJSON3.errorIntent));
};
var errorUtils = {
  buildErrorObject: buildErrorObject,
  isRateLimitError: isRateLimitError
};

export { errorUtils as default };
//# sourceMappingURL=errorUtils.js.map
